import Sidebar from '../components/Sidebar';
import FileSystemPanel from '../components/FileSystemPanel';
import UsagePanel from '../components/UsagePanel';
import { Helmet } from 'react-helmet';
import { FileSystemProvider } from './FileSystem';
import CookieConsent from 'react-cookie-consent';
import withAuthenticationRequired from './Auth/withAuthenticationRequired';
import { PluginsProvider } from './Plugins';

const Dashboard: React.FC = () => {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Dashboard | Protonfile</title>
      </Helmet>
      <Sidebar />
      <FileSystemProvider>
        <PluginsProvider>
          <FileSystemPanel />
          <UsagePanel />
        </PluginsProvider>
      </FileSystemProvider>
      <CookieConsent>
        This website uses cookies to enhance the user experience.
      </CookieConsent>
    </>
  );
};

export default withAuthenticationRequired(Dashboard);
